import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { Colors } from "../../utilities/colors";
import Button from "../button/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const CustomModalWrapper = styled(Modal)`
  .modal-content {
    border-radius: 100px;
    padding: 20px;
  }
`;

const HeaderLabel = styled.h3`
font-size: 28px;
color: ${Colors.pink};
font-weigth: 500;
`;

const HeaderDiv = styled.div`
text-align: center;
padding-top: 10px;
margin-bottom: 10px;
`;

const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ContentLabel = styled.h4`
font-size: 22px;
color: ${Colors.dark};
font-weigth: 500;
text-align: center;
`;

const ButtonWrapper = styled.div`
display: flex;
flex-direction: row;
gap: 40px;

  @media (max-width: 599px) {
    gap: 16px;
    width: 100%;
    justify-content: center;

    button {
      width: 120px;
      padding: 10px 0;
      font-size: 16px;
    }
  }
`

export default function UpdateSelfIntroPopUp({show, close, setShowUpdateModal, pop_status, redirectToUpdateInstituition, onCancel}){
  const { t }= useTranslation();
  
    const displayCheck = () => {
        localStorage.setItem("pop_status", 4);
        setShowUpdateModal(false);
        redirectToUpdateInstituition();
      };

    return(
        <CustomModalWrapper show={show} size="md" backdrop="static" onHide={close} centered>
            <HeaderDiv>
                <HeaderLabel>{t("Update About Me Information")}</HeaderLabel>
            </HeaderDiv>

            <ContentDiv>
                <ContentLabel>{t("Please update your information in")} <strong>{t("About me")}</strong></ContentLabel>
                <ButtonWrapper>
                <Button name={t("Proceed")} onClick= {displayCheck}/>
                <Button name={t("Later")} secondary onClick={onCancel}/>
                </ButtonWrapper>
            </ContentDiv>
        </CustomModalWrapper>
    )
}